import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService, DspxCardSetBaseFormComponent, SpinnerService } from 'dspx-core';
import { API_ENDPOINTS } from '../../constants/api-endpoints.constants';
import { TEMPLATES } from '../../constants/templates.constants';
import { AppDataService } from '../../services/app-data.service';
import { ExcelImportService } from '../../services/excel-import.service';
import { ResponseParserService } from '../../services/response-parser.service';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';

@Component({
  selector: 'app-gl-string-mapping-list',
  templateUrl: './gl-string-mapping-list.component.html',
  styleUrl: './gl-string-mapping-list.component.scss'
})
export class GLStringMappingListComponent extends BaseCardSetListComponent implements OnInit, OnDestroy {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  activeDialog: string = '';

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    protected excelImportService: ExcelImportService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.glStringMappingList,
      () => API_ENDPOINTS.dashboard.getGlStringMappings,
      false);
  }

  ngOnInit(): void {
    this.route.url.subscribe((url) => {
      if (url.length === 0) {
        // In the case where this component is being loaded as part of the default (empty) route, we want to force it
        // to the Reference Data List route so that the menu will highlight the selected option.
        this.router.navigate(['/', ROUTE_CONSTANTS.glStringMapping.list]);
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
  }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
    // No filters are implemented in this dashboard
  }

  actionButton_glStringMappingGrid_datagrid_new_Clicked(event: any) {
    this.router.navigate(['/', ROUTE_CONSTANTS.glStringMapping.prefix]);
  }

  actionButton_glStringMappingGrid_datagrid_edit_Clicked(event: any) {
    this.router.navigate(['/', ROUTE_CONSTANTS.glStringMapping.prefix, event.event.data.id]);
  }
}
